export const HOT_TAGS = [
  { name: '深夜牵手', type: '实锤' },
  { name: '同款吊坠', type: '暗糖' },
  { name: '酒店同房', type: '实锤' },
  { name: '工作室否认', type: '反转' },
  { name: '离婚声明', type: '实锤' },
  { name: '删博清空', type: '疑云' },
  { name: '拍戏生情', type: '侧证' },
  { name: '旧照考古', type: '暗糖' },
  { name: '小号自曝', type: '自锤' },
  { name: '狗仔跟拍', type: '实锤' },
  { name: '知情人爆料', type: '爆料' },
  { name: '行程对不上', type: '疑云' },
];

export const NEWS = [
  {
    id: 'n1',
    title: '三线小生深夜送某女星回小区，被拍到搂腰全程未松手',
    time: '08-12 23:40',
    hot: 98.6,
    label: '实锤',
    source: '娱扒头条',
    desc: '多位路人偶遇并发布视频，两人状态亲密，女方是已婚多年的当红小花旦。',
  },
  {
    id: 'n2',
    title: '男主持婚内出轨被拍，工作室首发声却错漏百出',
    time: '08-12 20:12',
    hot: 96.1,
    label: '反转',
    source: '吃瓜前线',
    desc: '声明日期写成明天，网友质疑“是不是连时间线都没对好”，二次回应还在路上。',
  },
  {
    id: 'n3',
    title: '实力派演员被曝隐婚出轨，同款项链与旧照被逐帧比对',
    time: '08-12 16:05',
    hot: 93.4,
    label: '暗糖',
    source: '星光社',
    desc: '有人扒出两人多次佩戴同款饰品，疑在片场认识后私下往来已超过一年。',
  },
  {
    id: 'n4',
    title: '离婚半年后男方晒“新欢”同游，前妻发文疑影射婚内故事',
    time: '08-12 12:44',
    hot: 90.2,
    label: '后续',
    source: '桃色观察',
    desc: '前妻配文“当年的一些细节，终于有人看懂了”，评论区吵成一片。',
  },
  {
    id: 'n5',
    title: '练习生妈妈爆料：出道夜见过女方妈妈探班',
    time: '08-11 22:30',
    hot: 87.9,
    label: '爆料',
    source: '娱乐情报局',
    desc: '自称家属的账号放出多段聊天截图，指向一段持续数年的地下恋情。',
  },
  {
    id: 'n6',
    title: '导演被拍与女二聚餐后同回酒店，女方已订婚',
    time: '08-11 18:09',
    hot: 84.7,
    label: '实锤',
    source: '娱扒头条',
    desc: '订婚对象不在场，狗仔蹲守一夜未见到女方下楼，双方暂无回应。',
  },
];

export const WALL_EVENTS = [
  {
    id: 'w1',
    type: '已实锤',
    person: '言 深',
    role: '偶像男歌手',
    hot: 99.1,
    desc: '狗仔三个月跟拍，五次同框画面已分集放出，本人已承认并暂退节目。',
  },
  {
    id: 'w2',
    type: '在回应',
    person: '苏 梨',
    role: '新人女演员',
    hot: 95.3,
    desc: '被曝与已婚制作人交往，工作室称“仅工作关系”，等待本人表态。',
  },
  {
    id: 'w3',
    type: '待续锤',
    person: '岑 野',
    role: '综艺常驻嘉宾',
    hot: 88.6,
    desc: '旧照与聊天记录陆续流出，经纪公司称正在收集证据走法律程序。',
  },
  {
    id: 'w4',
    type: '已回应',
    person: '乔 晚',
    role: '唱作人',
    hot: 82.4,
    desc: '正面回应争议并道歉，承认“处理私事欠妥”，但否认婚内出轨。',
  },
];

export const RANK_LIST = [
  { rank: 1, name: '言 深', word: '综艺停录', heat: 993000 },
  { rank: 2, name: '苏 梨', word: '制作人门', heat: 872000 },
  { rank: 3, name: '岑 野', word: '旧照流出', heat: 761000 },
  { rank: 4, name: '乔 晚', word: '公开道歉', heat: 690000 },
  { rank: 5, name: '程 屿', word: '同游曝光', heat: 584000 },
  { rank: 6, name: '林 亦', word: '删博清空', heat: 520000 },
];

export const TIMELINE = [
  { date: '08-12', items: ['言深承认出轨并暂退录制', '苏梨工作室发声明称仅工作关系'] },
  { date: '08-11', items: ['狗仔放出第三次同框正片', '岑野方称正在取证走法律程序'] },
  { date: '08-10', items: ['乔晚公开道歉回应', '网友扒出程屿同游旧照'] },
  { date: '08-09', items: ['林亦清空大半微博引发热议', '新一批聊天截图被晒出'] },
];

export const CELEB_SIDES = [
  {
    side: '男星',
    intro: '已婚男性艺人婚内出轨线索汇总，时间线与同框画面逐条归档，方便对照核实。',
    persons: ['言深', '程屿', '岑野', '温迟'],
    tags: ['言深承认出轨', '程屿同游', '岑野取证中', '温迟否认'],
  },
  {
    side: '女星',
    intro: '已婚女性艺人争议事件与绯闻复盘，从爆料到回应全程记录，避免断章取义。',
    persons: ['苏梨', '乔晚', '夏枝', '宋旖'],
    tags: ['苏梨制作人门', '乔晚道歉', '夏枝删除动态', '宋旖同款'],
  },
];

export const FAQS = [
  {
    q: '为什么把“男星/女星”分开归类？',
    a: '婚内出轨相关事件往往牵涉多位当事人与不同争议角度，分开归类便于按人物快速查找线索，也能区分“本人承认”“知情人爆料”“纯猜测”等不同可信度，避免混为一谈。',
  },
  {
    q: '“实锤 / 疑云 / 暗糖”这些标签怎么区分？',
    a: '“实锤”指有同框、声明、聊天记录等直接证据；“疑云”多来自行程、删博等间接线索；“暗糖”则是一些同款、旧照的联想。标签只是整理工具，不代表最终定性。',
  },
  {
    q: '内容来源可靠吗？会不会误伤当事人？',
    a: '本站仅做公开信息的整理与归档，标注“爆料”“疑云”的条目都有明确来源提示。任何人未定论前，我们都建议理性看待，不传播未经证实的内容。',
  },
  {
    q: '人物后续动态在哪里更新？',
    a: '每起事件的“后续”都会在时间线模块持续追加，工作室回应、删博、道歉等动作会第一时间补录，方便大家跟进同一个瓜的完整走向。',
  },
  {
    q: '能不能搜索某个具体人物？',
    a: '可以。顶部搜索框支持按姓名、事件关键词检索，也能用“男星/女星/实锤/疑云”等标签快速过滤，直达你想找的人物与争议。',
  },
];

export const HOT_WORDS = ['公开道歉', '暂退录制', '声明错漏', '删除动态', '取证回应', '旧照考古'];